export const COMMIT_HASH = 'd4b15b939cc021a57623604deb8c983467336670';
